import { useState } from "react";
import SolicitarDevolucaoStep1 from "./step-1";
import SolicitarDevolucaoStep2 from "./step-2";

export default function NewRequestPage({ onBack }) {
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const [fieldsData, setFieldsData] = useState({
    idGrupoEconomico: null,
    idPessoa: null,
    cnpj: null,
    groupName: null,
    socialName: null,
  });
  const [items, setItems] = useState([]);
  const [itemsWithMotivos, setItemsWithMotivos] = useState([]);
  const [productImages, setProductImages] = useState([]);
  const [pesoLiquido, setPesoLiquido] = useState(0);
  const [solicitacao, setSolicitacao] = useState();
  const [motivoGeral, setMotivoGeral] = useState(null);
  const [defeitoGeral, setDefeitoGeral] = useState(null);

  const handleClear = () => {
    setStep(1);
    setFieldsData({
      idGrupoEconomico: null,
      idPessoa: null,
      cnpj: null,
      groupName: null,
      socialName: null,
    });
    setSolicitacao(undefined);
    setItems([]);
    setItemsWithMotivos([]);
    setProductImages([]);
    setPesoLiquido(0);
    setMotivoGeral(null);
    setDefeitoGeral(null);
  };

  const commonProps = {
    fieldsData,
    setFieldsData,
    setStep,
  };

  const step1Props = {
    ...commonProps,
    isLoading,
    setIsLoading,
    item: itemsWithMotivos.length > 0 ? itemsWithMotivos : items,
    setItem: setItems,
    setItemsWithMotivos,
    setProductImages,
    setPesoLiquido,
    onBack: onBack,
    motivoGeral,
    setMotivoGeral,
    defeitoGeral,
    setDefeitoGeral,
    solicitacao,
  };

  const step2Props = {
    ...commonProps,
    handleClear,
    setSolicitacao,
    setItem: setItems,
    returnToInitialPage: onBack,
    items: items,
    productImages,
    pesoLiquido,
    itemsWithMotivos,
    motivoGeral,
    defeitoGeral,
  };

  return (
    <>
      <div style={{ display: step === 1 ? "block" : "none" }}>
        <SolicitarDevolucaoStep1 {...step1Props} />
      </div>
      <div style={{ display: step === 2 ? "block" : "none" }}>
        <SolicitarDevolucaoStep2 {...step2Props} />
      </div>
    </>
  );
}
